import React from 'react'
import ItinraryOptionButton from '../itineraryOptions/ItineraryOptionButton'
import ItineraryTimeOptionButton from '../itineraryOptions/ItineraryTimeOptionButton'
import s from './ItinerarySubHeader.less'

const ItinerarySubHeader = () => (
  <>
    <div className={s.itinerarySubHeader}>
      <ItineraryTimeOptionButton className={s.itineraryTimeOptionButton} />
      <ItinraryOptionButton className={s.itineraryOptionButton} />
    </div>
  </>
)

export default ItinerarySubHeader
